import ArrowLink from "components/links/ArrowLink";
import { BodyPart, MongenInterface, MongenRace, MongenState, NFTType, PlotInterface, PlotType, Rarity } from "interfaces";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { setUserInfo } from "reducer/user.slice";
import { api, ui, utils } from "services";
import { RewardLayout } from "./reward";

export const ExchangePoint = () => {
    const { rarity } = useParams();
    const [list, setList] = useState([])
    const [selectItems, setSelectedItems] = useState([])
    const [selectedIdxs, setSelectedIdxs] = useState([]);
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [listComponent, setListComponent] = useState(<></>)
    const [plusPoint, setPlusPoint] = useState(0);
    const nav = useNavigate();
    const [selectedType, setSelectedType] = useState(null);
    const dispatch = useDispatch();
    const [vaultConfig, setConfig] = useState([]);
    const [trigger, setTrigger] = useState(false);
    const [configData, setConfigData] = useState([])

    const getExchangeItems = async () => {
        try {
            let rs = await api.getInventory(Number(rarity));
            const { mongenInfos, plotInfos } = rs;
            let data: any = [];

            mongenInfos.forEach((mongenInfo: any) => {
                if (mongenInfo[MongenInterface.mongen_state] === MongenState.Idle) {
                    let rarity = mongenInfo[MongenInterface.dna][BodyPart.Aura][0]
                    let nftData = utils.getItemInfo({
                        type: NFTType.Mongen,
                        configData
                    })
                    data.push({
                        type: NFTType.Mongen,
                        dna: mongenInfo[MongenInterface.dna],
                        id: mongenInfo[MongenInterface.id],
                        rarity,
                        point: nftData?.points?.[rarity] ?? 0
                    })
                }
                else {
                    let rarity = mongenInfo[MongenInterface.dna][1][0]
                    let nftData = utils.getItemInfo({
                        type: NFTType.Mongen,
                        configData
                    })
                    data.push({
                        type: NFTType.SoulCore,
                        id: mongenInfo[MongenInterface.id],
                        rarity,
                        race: mongenInfo[MongenInterface.dna][BodyPart.Form][0],
                        point: nftData?.points?.[rarity] ?? 0
                    })
                }
            })

            plotInfos.forEach((plotInfo: any) => {
                let rarity = plotInfo[PlotInterface.rarity] ?? Rarity.Common
                let plot_type = plotInfo[PlotInterface.plot_type] ?? PlotType.LandCore
                let nftData = utils.getItemInfo({ type: NFTType.Plot, plot_type, configData });
                data.push({
                    type: NFTType.Plot,
                    rarity,
                    plot_type,
                    race: plotInfo[PlotInterface.plot_race] ?? MongenRace.Beast,
                    sub_plot_type: plotInfo[PlotInterface.sub_plot_type],
                    id: plotInfo[PlotInterface.id],
                    point: nftData?.points?.[rarity] ?? 0
                })
            })

            setList(data)
        } catch (err) {
            console.log({ err })
        } finally {
        }
    }

    const exchange = async () => {
        try {
            setLoading(true)
            let data = await api.exchangePoint({
                mongen_ids: selectItems.filter((i) => [NFTType.Mongen, NFTType.SoulCore].includes(i.type)).map((i) => i.id),
                plot_ids: selectItems.filter((i) => [NFTType.Plot].includes(i.type)).map((i) => i.id),
                rarity: Number(rarity)
            })
            if (data) {
                ui.alertSuccess("Exchange success !", "")
                let newData = list.map((e, idx) => {
                    if (selectedIdxs.includes(idx)) {
                        return null;
                    }
                    return e;
                }).filter((i) => i !== null)
                setSelectedIdxs([])
                setSelectedItems([])
                setList(newData);
                setPlusPoint(0);
                dispatch(setUserInfo({ ...data.customerInfo }));
                setTrigger(!trigger)
            }
        } catch (err: any) {
            ui.alertFailed("Exchange failed !", t(err?.message ?? err))
        } finally {
            setLoading(false)
        }
    }

    const getVault = async () => {
        let rs = await api.getVault();
        if (rs?.length) {
            setConfig(rs)
        }
    }

    const getConfig = async () => {
        let rs = await api.getConfig();
        if (rs.NFTExchangePoint) {
            setConfigData(rs.NFTExchangePoint)
        }
    }

    useEffect(() => {
        getConfig();
    }, [])

    useEffect(() => {
        getVault()
    }, [trigger])

    useMemo(() => {
        setListComponent(
            <div className="mx-auto h-full overflow-y-scroll flex flex-wrap gap-4 items-center justify-left p-4 py-2 pb-16 mt-6" style={{
                maxHeight: 'calc(100vh - 250px)'
            }}>
                {list.map((i, idx) => {
                    if (selectedType !== null && selectedType !== i.type) {
                        return <></>
                    }
                    return (
                        <RewardLayout data={i} onSelect={() => {
                            try {
                                if (!loading) {
                                    if (!selectedIdxs.includes(idx)) {
                                        setSelectedIdxs([...selectedIdxs, idx])
                                        setSelectedItems([...selectItems, i])
                                        setPlusPoint(plusPoint + i.point)
                                    } else {
                                        setSelectedIdxs(selectedIdxs.filter((item) => item !== idx))
                                        setSelectedItems(selectItems.filter((item) => JSON.stringify(i) !== JSON.stringify(item)))
                                        setPlusPoint(plusPoint - i.point)
                                    }
                                }
                            } catch (err) {
                                console.log(err)
                            }
                        }}
                            isActive={selectedIdxs.includes(idx)}
                        />
                    )
                })}
            </div>
        )
    }, [list, selectedIdxs, selectedType, loading])

    useEffect(() => {
        getExchangeItems();
    }, [rarity, configData])

    if (!configData) {
        return;
    }

    return (
        <div className="w-screen" style={{
            height: "calc(100vh - 122px)"
        }}>
            <div className="text-white ml-8 mt-10 flex self-center">
                <ArrowLink direction="left" onClick={() => {
                    nav(-1)
                }}>
                    Back
                </ArrowLink>
            </div>

            <div className="w-4/5 mx-auto">
                <div className="text-3xl font-cookie-run text-gradient mt-4">
                    Exchange {Rarity[Number(rarity)]} point
                </div>

                <div className="relative rounded-lg">
                    {listComponent}
                </div>
            </div>

            <div className="absolute bottom-0 bg-[#1F1D24] w-full px-10">
                <div className="text-white text-xl py-2 pb-4 font-extrabold main-font-bold text-right flex flex-wrap gap-10 float-right">
                    <div className="self-center">
                        <div className="flex gap-1 text-sm">
                            <div className={`text-${Rarity[Number(rarity ?? 0)]}`}>
                                <div>{Rarity[Number(rarity ?? 0)].toString()}</div>
                            </div>
                            <div className="">+{plusPoint} Point</div>
                        </div>
                        <div className="text-sm text-[#B3ADA8] text-left">
                            New {Rarity[Number(rarity ?? 0)].toString()} score: {Number(vaultConfig?.[Number(rarity)]?.myPoint ?? 0) + plusPoint} Point
                        </div>
                    </div>
                    <div className="w-[150px] mt-1">
                        <img src="/assets/images/button/confirm_btn.png" className="cursor-pointer" alt="confirm"
                            onClick={
                                () => ui.confirm(t("This NFT will be burned and can no longer be used, this action cannot be undone. Are you sure you want to burn this item to exchange points?"), exchange, () => { })
                            } />
                    </div>
                </div>
            </div>
        </div>
    )
}